// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { WorkingHoursFragmentDoc } from '../../cms/WorkingHours.fragment.generated';
export const FooterItemWorkingHoursFragmentDoc = gql`
    fragment footerItemWorkingHours on FooterColumnItemWorkingHours {
  workingHours(locale: $locale) {
    ...workingHours
  }
}
    ${WorkingHoursFragmentDoc}`;